import React from 'react';
import { Grid } from '@mui/material';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import TextFormField from '../../../../shared/forms/fields/TextFormField';

type Props = {
  readonly readOnly: boolean;
}

const DeploymentInfoFields = (props: Props) => {

  const { readOnly } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} style={{ marginTop: 10 }}>
          <Field
            name="serverId"
            disabled={readOnly}
            fullWidth
            component={TextFormField}
            label="Server ID"
          />
        </Grid>
        <Grid item xs={12} md={6} style={{ marginTop: 10 }}>
          <Field
            name="author"
            disabled={readOnly}
            fullWidth
            component={TextFormField}
            label="Author"
          />
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Field
          fullWidth
          disabled={readOnly}
          label="Date of creation"
          name="createdDate"
          component={TextFormField}
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Field
          fullWidth
          disabled={readOnly}
          label="Commit ID"
          name="commitId"
          component={TextFormField}
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Field
          fullWidth
          disabled={readOnly}
          label="Last modified"
          name="lastModifiedDate"
          component={TextFormField}
        />
      </Grid>
      <Grid style={{ marginTop: 20 }}>
        <Typography variant="h5">
          Status
        </Typography>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5} style={{ marginTop: 10 }}>
          <Field
            name="status.state"
            fullWidth
            disabled={readOnly}
            component={TextFormField}
            label="Status"
          />
        </Grid>
        <Grid item xs={12} md={7} style={{ marginTop: 10 }}>
          <Field
            name="status.createdDate"
            fullWidth
            disabled={readOnly}
            component={TextFormField}
            label="Date of creation"
          />
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Field
          fullWidth
          disabled={readOnly}
          label="Process ID"
          name="status.processId"
          component={TextFormField}
        />
      </Grid>
    </>
  );
};

export default DeploymentInfoFields;
